module.exports = __webpack_public_path__ + "static/media/bujyeko_rahe_xau.b1524cf5.ogg";